import { useState, useEffect } from 'react';

const ToTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 100);
    };
    window.addEventListener('scroll', toggleVisibility);
    toggleVisibility();
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  if (!visible) return null;

  return (
    <button onClick={scrollTop} className={`toTop ${visible ? 'visible' : ''}`}>
      ↑
    </button>
  );
};

export default ToTop;
